module.exports = __webpack_public_path__ + "media/application/assets/fonts/BebasNeue-Regular-558c0b09724cc2d2f36fee12652d8698.woff";